import PropTypes from 'prop-types';
import React from 'react';

import StandardSelect from 'app/components/common/standard-select';
import countries from 'app/helpers/countries';

class CountryPicker extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasTouched: false,
    };

    this.onSelectCountry = this.onSelectCountry.bind(this);
  }

  get options() {
    const {justFlag} = this.props;
    return countries.sorted.map((country) => {
      const obj = {label: `${country.flag} ${country.name}`, value: country.code};
      if (justFlag) obj.selectedLabel = country.flag;
      return obj;
    });
  }

  onSelectCountry(code) {
    this.props.onChange(code || null);
  }

  render() {
    const {className, code, allowClear, justFlag} = this.props;
    const flagClass = justFlag ? 'country-picker-flag-only' : '';

    return (
      <StandardSelect className={`${className} ${flagClass}`} options={this.options} onSelect={this.onSelectCountry} value={code} label="Select a country..." allowClear={allowClear} searchLabel="Type to filter..." />
    );
  }

}

CountryPicker.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  allowClear: PropTypes.bool,
  justFlag: PropTypes.bool, // will show a smaller input with just the flag instead of the flag and name
};

CountryPicker.defaultProps = {
  className: '',
  code: null,
  allowClear: false,
  justFlag: false,
};

export default CountryPicker;
